import { render, staticRenderFns } from "./FacialRecognition.vue?vue&type=template&id=1e008526&scoped=true"
import script from "./FacialRecognition.vue?vue&type=script&lang=js"
export * from "./FacialRecognition.vue?vue&type=script&lang=js"
import style0 from "./FacialRecognition.vue?vue&type=style&index=0&id=1e008526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e008526",
  null
  
)

export default component.exports